export default __webpack_public_path__ + "static/media/Video.d0bfd148.mp4";